import LogOutSection from 'Components/User/LogOutSection';
import { actions } from 'Data/ReduxViewModels/User';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { Message } from '../Core';
import { PageSection } from '../Layout';
import ChangePassword from '../User/ChangePassword';
import Page from './Core/Page';

const paths = {
  changePassword: 'change-password',
  preferences: 'preferences',
  session: 'session',
};

const links = [
  { uri: paths.changePassword, text: 'Change Password', heading: 'Account' },
  { uri: paths.session, text: 'Session' },
];

const UserSettingsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const personName = useSelector((state) => state.user.data?.Name);
  const isRedirecting = useSelector((state) => state.user.changePassword?.isRedirecting);
  useEffect(() => {
    if (isRedirecting) {
      navigate('/');
      dispatch(actions.clearUserPasswordRedirect());
    }
  }, [navigate, isRedirecting, dispatch]);
  return (
    <Page navLinks={links.map((link) => ({ ...link, uri: link.uri }))} navHeading={personName}>
      <Routes>
        <Route path={`/`} element={<Navigate to="/user/session" replace />} />
        <Route
          path={paths.changePassword}
          element={
            <PageSection heading="Change Password">
              <ChangePassword onSuccess={true} />
            </PageSection>
          }
        />
        <Route path={paths.session} element={<LogOutSection />} />
        <Route
          path="*"
          element={
            <PageSection>
              <Message error>User setting page not found. Please select an item from the menu.</Message>
            </PageSection>
          }
        />
      </Routes>
    </Page>
  );
};

export default UserSettingsPage;
